import { partners } from '@/mocks/home';
import { fetchPartnerList } from '@/services/content';
import { adaptPartners } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import SectionHeading from '@/components/base/SectionHeading';

export default function PartnersSection() {
  // 接口失败时降级为 mock 数据
  const { data: partnerList } = useRequest(
    () => fetchPartnerList(1, 100).then((res) => adaptPartners(res.list)),
    { fallback: partners },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (partnerList.length === 0) return null;

  return (
    <section id="partners" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="合作伙伴"
          title="携手学会、院校与产业伙伴"
          description="联合行业组织、科研院校与产业力量，共同建设中西医结合智慧生态。"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {partnerList.map((partner) => (
            <div
              key={partner.id}
              className="group flex flex-col items-center justify-center gap-4 px-5 py-7 md:px-8 md:py-9 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 hover:bg-accent-50/60 transition-colors cursor-pointer"
            >
              <div className="w-full h-16 md:h-24 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  title={`${partner.short} 生态合作伙伴`}
                  className="max-h-full max-w-full object-contain mix-blend-multiply grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition duration-300"
                />
              </div>
              <span className="text-xs md:text-sm text-foreground-600 text-center leading-snug line-clamp-2">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}